import { Link } from 'react-router-dom';
import styles from './style.module.css';
import Moment from 'react-moment';
import 'moment/locale/ru';
import { FiDownloadCloud } from 'react-icons/fi';

const ConferenceCard = ({
    id,
    name,
    start_date,
    end_date,
    conference_doc,
    conference_school
}) => {
    return (
        <div className={styles.card}>
            <div className={styles.year}>
                <Moment locale='ru' format='YYYY'>
                    {start_date}
                </Moment>
            </div>
            <div className={styles.content}>
                <div className={styles.title}>
                    <Link to={`/conferences/${id}/`}>{name}</Link>
                </div>
                <div className={styles.date}>
                    <Moment locale='ru' format='D MMMM'>
                        {start_date}
                    </Moment>
                    -
                    <Moment locale='ru' format='LL'>
                        {end_date}
                    </Moment>
                </div>
                <div className={styles.docs}>
                    <ul>
                        {conference_doc.map(docs => {
                            return (
                                <li><FiDownloadCloud /> <a target='blank' href={docs.file}><span>{docs.title}</span></a></li>
                            )
                        })}
                    </ul>
                </div>
                <div className={styles.schools}>
                    <ul>
                        {conference_school.map((school, index) => (
                            conference_school.length - 1 === index ? null : <li>{school.name}</li>
                        )
                        )}
                    </ul>
                </div>
                <Link to={`/conferences/${id}/`}>Подробнее</Link>
            </div>
        </div>
    );
}

export default ConferenceCard;
